import * as React from "react";
import {Link} from "react-router-dom";
import {ProductsEnum} from "@ferry/journey-services";

interface IProps {
    policyNumber: string;
    invoiceId: number;
    label: string;
    cssClass: string;
    id: string;
    reuseCard: boolean;
}

export class MissedPaymentLink extends React.Component<IProps> {

    public render() {
        // FER-7308 - this is strange that there are different pages and one of them is called payOverdueInstalment
        // for annual payments. Have raised a ticket to review and improve the payment screen logic.
        // Ideally, the payment screen should decide whether to redirect to a new card payment or the page with choice instead of being hardcoded in the link.
        const paymentPage: string = this.props.reuseCard ? "payOverdueInstalment" : "missedPolicyPayment";

        return (
            <Link id={this.props.id}
                  className={this.props.cssClass}
                  state={{
                      verifyCardFailed: false,
                      product: ProductsEnum.WOLF_MOTOR
                  }}
                  to={`/dashboard/account/${paymentPage}/${this.props.policyNumber}/${this.props.invoiceId}`}
            >
                {this.props.label}
            </Link>
        )
    }
}
